import {Personnel} from "./personnel";
import {Maintenance} from "./maintenance";
import {CalendarEvent} from "./calendar-event";
import {Equipment} from "./equipment";
import {PhysicalAsset} from "./physical-asset";
import {Procedure} from "./procedure";

export enum AssistanceType {
  LIVE_MAINTENANCE,
  TRAINING,
  EXTERNAL_MAINTENANCE
}

export class Assistance implements Partial<Maintenance> {
  id: string;
  status: number;
  fieldWorker: Personnel;
  event: CalendarEvent;
  equipment: PhysicalAsset;
  maintenance: Maintenance;
  procedure: Procedure;
}
